var map = {
	"./site-logo-desktop-footer.svg": 91693,
	"./site-logo-desktop.svg": 3675,
	"./site-logo-drawer-mobile.svg": 39765,
	"./site-logo-drawer.svg": 8918,
	"./site-logo-external.svg": 73136,
	"./site-logo-mobile-drawer.svg": 17351,
	"./site-logo-mobile.svg": 34623,
	"./site-logo-sm.svg": 55013,
	"./site-logo-tv.svg": 79875,
	"./site-logo-wrapper-mobile-scrolled.svg": 92946,
	"./site-logo-wrapper-mobile.svg": 96765,
	"./site-logo-wrapper-scrolled.svg": 54751,
	"./site-logo-wrapper.svg": 99166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21703;